import { debug } from './logging'

/**
 * Tests if url meet conditions to show spend data
 * @param isSMC if user is in SMC org show spend data
 * @param filters if filters are empty hide spend data otherwise show spend data if filters have any of the following [`source` and `trackableCampaignId aka Ad Campaign`].
 * @returns
 */
export function showSpend(isSMC: boolean, filters: string | undefined | null): boolean {
  const platformRegex = /(?:[?&]|^)platform=([^&]+)(?=&|$)/i
  const campaignRegex = /trackableCampaignId/i
  debug(`showSpend`, `filters`, filters)
  if (isSMC || filters == null) return isSMC
  const decoded = decodeURIComponent(filters)
  return platformRegex.test(decoded) || campaignRegex.test(decoded)
}
